let counter = 0;

export const generateId = (): string => `fe-${++counter}`;

export const resetIdCounter = (): void => { counter = 0; };
